import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromNotificationState from './notification.state';

export const selectNotificationsState = createFeatureSelector<fromNotificationState.NotificationState>(fromNotificationState.notificationFeatureKey);

export const selectNotifications = createSelector(
  selectNotificationsState,
  state => state.notificationSummary
);
